<div class="popup-wrap popup-wrap-alt danger-message t-bg-primary" style="outline:none; height: 100vh; overflow: auto; position: fixed; top: 0; left: 0; z-index: 1050;">
    <div class="form-block flxClmn" style="position: relative; height: 97%; outline: none" tabindex="0">
		 <span class="title" style="margin:0">
		 {{'support.contactUs' | translate}}
		 </span>
        <hr style="margin:0.7rem 0"/>
        <a class="close1" (click)="gs.toggleSupportForm(false);"><i class="zmdi zmdi-close" style="font-size:24px;"></i></a>
        <p style="text-align: center; font-size: 0.75rem; padding: 15px 5px; background: #e2e2e240;">{{'support.contactUsDescription' | translate}}</p>
        <!--contact form-->
        <div class="flxClmn vSpace2 t-bg-primary f-1-0" style="margin-top: 10px">
            <div class="flxClmn vSpace1">
                <!--OS-->
                <span>{{'support.operatingSystem' | translate}}</span>
                <div class="dropdown" style="width:100%;margin:0;top:0;z-index:auto;"
                     (clickOutside)="this.ddsOS = false;"
                     [ngClass]="{'active' : ddsOS}"
                     (click)="ddsOS = !ddsOS"
                     (focus)="ddsOS=true"
                     (blur)="ddsOS=false">
                    <div class="select" style="padding:10px;float:initial">
                        <span>{{OSSelectedType}}</span>
                        <i class="fa fa-chevron-left"></i>
                    </div>
                    <ul class="dropdown-menu" style="overflow:auto"
                        [ngClass]="{'active' : ddsOS}"
                        [ngStyle]="ddsOS && {'max-height':'none'}">
                        <li (click)="OSSelectedType = option"
                            *ngFor="let option of OSTypes"
                            [attr.id]="option">
                            {{option}}
                        </li>
                    </ul>
                </div>
            </div>
            <!--Issue type-->
            <div class="flxClmn vSpace1">
                <span>{{'support.issueType' | translate}}</span>
                <div class="dropdown" style="width:100%;margin:0;top:0;z-index:auto;"
                     (clickOutside)="this.dssRsn = false;"
                     [ngClass]="{'active' : dssRsn}"
                     (click)="dssRsn = !dssRsn"
                     (focus)="dssRsn=true"
                     (blur)="dssRsn=false">
                    <div class="select" style="padding:10px;float:initial">
                        <span [ngStyle]="!reasonSelected && {'color':'var(--t-gray2)'}">{{reasonSelected || ('support.issueTypePlaceholder' | translate)}}</span>
                        <i class="fa fa-chevron-left"></i>
                    </div>
                    <ul class="dropdown-menu" style="overflow:auto"
                        [ngClass]="{'active' : dssRsn}"
                        [ngStyle]="dssRsn && {'max-height':'none'}">
                        <li (click)="reasonSelected = option"
                            *ngFor="let option of reason"
                            [attr.id]="option">
                            {{option}}
                        </li>
                    </ul>
                </div>
            </div>

            <!--Title-->
            <div class="flxClmn vSpace1">
                <span>{{'support.title' | translate}}</span>
                <input type="text" style=" height: 35px; width: 100%"
                       placeholder="{{'support.titlePlaceholder' | translate}}"
                       autofocus
                       [(ngModel)]="messageTitle">
            </div>

            <!--Message-->
            <div class="flxClmn vSpace1">
                <span>{{'support.message' | translate}}</span>
                <textarea style="height:15vh; min-height: 80px; resize: none;"
                          placeholder="{{'support.messagePlaceholder' | translate}}"
                          [(ngModel)]="textMessage"></textarea>
            </div>

            <!--Attach a file-->
            <div class="flxClmn vSpace1 bs-enabled">
                <span>{{'support.attachFile' | translate}}</span>
                <div class="w-100 flex-column position-relative" style="height: 100px; border: solid 1px #cccccc; border-radius: 4px;"
                     [uploader]="uploader"
                     ng2FileDrop
                     [ngClass]="{'hover': mouseOverAttachment, 'drag-over': mouseOverAttachment}"
                     (onFileDrop)="selectFile($event)"
                     (fileOver)="mouseOverAttachment = $event || false;">
                    <input id="contactUsAttachment" type="file"
                           multiple
                           ng2FileSelect
                           style="position: absolute; top: 0; left: 0; bottom: 0; right: 0; visibility: hidden;"
                           [uploader]="uploader"
                           (onFileSelected)="selectFile($event)"/>
                    <label class="cursor-pointer f-1-0 flex-column" for="contactUsAttachment">
                        <div class="flex-column centralize p-4 gap-2 text-muted hvr-darken f-1-0" *ngIf="!attachmentFile">
                            <i class="fa fa-paperclip" style="font-size: 1.5rem;"></i>
                            <span class="fw-500">{{'compose.files.addOrDragDrop' | translate}}</span>
                        </div>
                        <div class="d-flex centralize gap-2 f-1-0 px-4" *ngIf="attachmentFile">
                            <i class="fa fa-file"></i>
                            <span class="fw-500 fst-italic text-success" style="text-align: center;">{{_.truncate(attachmentFile.name, {'length': 50})}}</span>
                        </div>
                    </label>
                </div>
            </div>

            <div class="flxRow-center btn-block">
                <button type="button" style="margin: 10px; height: 30px;"
                        (click)="sendMessageToSupport()"
                        [disabled]="!textMessage.length || createTicketInProcess"
                        [ngStyle]="textMessage.length<1 && {'background':'gray', 'cursor':'not-allowed'}" class="btn">
                    <ng-container *ngIf="!createTicketInProcess">{{'support.send' | translate}}</ng-container>
                    <div class="loading-spinner" *ngIf="createTicketInProcess"></div>
                </button>
            </div>

            <div class="flxClmn-end f-1-0 animated fadeIn" *ngIf="errorMsg">
                <span style="color: var(--bs-danger);">{{errorMsg}}</span>
            </div>
        </div>
    </div>
</div>
